/**
 * The look of anything clickable that is *text*: brand colour, brandDark on hover, 200ms.
 *
 * This is the single definition of that rule — RingilButton's `link` mode composes
 * CLICKABLE_TEXT_BASE too, so a link button and an inline link react identically. Reach for
 * RingilButton `mode="link"` whenever the element is a plain onClick; use `clickableTextClass`
 * only where a real anchor is needed (react-router <Link>, <a href>), which a button cannot be.
 */
export const CLICKABLE_TEXT_BASE = 'cursor-pointer text-content-brand transition-all duration-200';

/** Button variants need `enabled:` so a disabled button does not light up; plain elements cannot. */
export const clickableTextClass = `${CLICKABLE_TEXT_BASE} hover:text-complementary-brandDark`;
